import {
  FETCH_STATE_NONE,
  FETCH_STATE_PENDING,
  FETCH_STATE_SUCCESS,
  FETCH_STATE_ERROR,
} from '~/config/constants';

const defaultState = () => ({
  resource: {},
  resourceFetchState: FETCH_STATE_NONE,
});

const mutations = {
  getResourceStart(state) {
    state.resourceFetchState = FETCH_STATE_PENDING;
  },
  getResourceSuccess(state, action) {
    Object.assign(state, { resource: action.payload.data });
    state.resourceFetchState = FETCH_STATE_SUCCESS;
  },
  getResourceError(state) {
    state.resourceFetchState = FETCH_STATE_ERROR;
  },
  resetState(state) {
    Object.assign(state, this.defaultState());
  },
};

const actions = {
  fetchData: ({ commit, rootGetters }, { groupBy }) => {
    commit(
      'api/fetch',
      {
        url: '/invoices/statistics',
        method: 'GET',
        headers: {
          ...rootGetters['auth/getHeaders'],
        },
        params: {
          group_by: groupBy,
        },
        onStart: ['statistics/getResourceStart'],
        onSuccess: ['statistics/getResourceSuccess'],
        onError: [
          'statistics/getResourceError',
          {
            type: 'flashMessages/addMessage',
            kind: 'error',
            key: 'getResourceError',
          },
        ],
      },
      { root: true },
    );
  },

  getResourceStart({ commit }) {
    commit('getResourceStart');
  },
  getResourceSuccess({ commit }, payload) {
    commit('getResourceSuccess', payload);
  },
  getResourceError({ commit }, payload) {
    commit('getResourceError', payload);
  },
  resetState({ commit }) {
    commit('resetState');
  },
};

const getters = {
  isResourceLoaded(state) {
    return state.resourceFetchState === FETCH_STATE_SUCCESS;
  },
  data(state) {
    return state.resource;
  },
};

export default {
  namespaced: true,
  state: defaultState,
  getters,
  actions,
  mutations,
};
